import { render, staticRenderFns } from "./ContentCourseDetails.vue?vue&type=template&id=436997fe&"
import script from "./ContentCourseDetails.vue?vue&type=script&lang=js&"
export * from "./ContentCourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContentCourseDetails.vue?vue&type=style&index=0&id=436997fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports